gsap.registerPlugin(ScrollTrigger);
// ====================================== ====================================== ====================================== SECTION 1
gsap.set(".co-home-1-image-5", { scale: 1 });
gsap.to(".co-home-1-image-5", {
  scrollTrigger: {
    trigger: "body",
    endTrigger: ".co-home-1",
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  scale: 1.025
});
gsap.set(".co-home-1-crumbles-image-1-1-img", { scale: 1, x: 0, y: 0 });
gsap.to(".co-home-1-crumbles-image-1-1-img", {
  scrollTrigger: {
    trigger: "body",
    endTrigger: ".co-home-1",
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  scale: 1.1,
  x: -15,
  y: -50
});
gsap.set(".co-home-1-crumbles-image-2-1-img", { scale: 1, x: 0, y: 0 });
gsap.to(".co-home-1-crumbles-image-2-1-img", {
  scrollTrigger: {
    trigger: "body",
    endTrigger: ".co-home-1",
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  scale: 1.1,
  x: -15,
  y: 75
});
// ====================================== ====================================== ====================================== SECTION 2
gsap.set(".co-home-2-child-cell-left-frame-3-img", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-2-child-cell-left-frame-3-img", {
  scrollTrigger: {
    trigger: ".co-home-2",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "-10%",
  y: "0%",
  rotate: -7.5
});
gsap.set(".co-home-2-child-cell-right-frame-3-img", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-2-child-cell-right-frame-3-img", {
  scrollTrigger: {
    trigger: ".co-home-2",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "10%",
  y: "0%",
  rotate: 7.5
});
// ====================================== ====================================== ====================================== SECTION 4
gsap.set(".co-home-4-content-crumble-frame", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-4-content-crumble-frame", {
  scrollTrigger: {
    trigger: ".co-home-4",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "0%",
  y: "-50%",
  rotate: -12.5
});
gsap.set(".co-home-4-grid-cell-4-frame", { rotate: 0, x: "0%" });
gsap.to(".co-home-4-grid-cell-4-frame", {
  scrollTrigger: {
    trigger: ".co-home-4",
    endTrigger: ".co-home-5-grid",
    start: "top bottom",
    end: "top top",
    scrub: true
  },
  rotate: -180,
  x: "0%"
});
gsap.set(".co-home-4-grid-cell-3-frame", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-4-grid-cell-3-frame", {
  scrollTrigger: {
    trigger: ".co-home-4",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "50%",
  y: "-20%",
  rotate: 12.5
});
gsap.set(".co-home-4-grid-cell-1-frame-4", { top: "-7.5%" });
gsap.to(".co-home-4-grid-cell-1-frame-4", {
  scrollTrigger: {
    trigger: ".co-home-4",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "0%"
});
// ====================================== ====================================== ====================================== SECTION 5
gsap.set(".co-home-6-content-crumble-frame", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-6-content-crumble-frame", {
  scrollTrigger: {
    trigger: ".co-home-6",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "20%",
  y: "-10%",
  rotate: -12.5
});
gsap.set(".co-home-6-grid-cell-3 img", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-6-grid-cell-3 img", {
  scrollTrigger: {
    trigger: ".co-home-6",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "-10%",
  y: "-20%",
  rotate: 7.5
});
gsap.set(".co-home-6-grid-cell-1-frame-4", { top: "-7.5%" });
gsap.to(".co-home-6-grid-cell-1-frame-4", {
  scrollTrigger: {
    trigger: ".co-home-6",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "0%"
});
// ====================================== ====================================== ====================================== SECTION 8
gsap.set(".co-home-8-content-crumble-frame", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-8-content-crumble-frame", {
  scrollTrigger: {
    trigger: ".co-home-8",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "-50%",
  y: "-10%",
  rotate: -37.5
});
gsap.set(".co-home-8-grid-cell-1-frame-4", { top: "-7.5%" });
gsap.to(".co-home-8-grid-cell-1-frame-4", {
  scrollTrigger: {
    trigger: ".co-home-8",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "0%"
});
gsap.set(".co-home-8-grid-cell-3 img", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-home-8-grid-cell-3 img", {
  scrollTrigger: {
    trigger: ".co-home-8",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "30%",
  y: "-10%",
  rotate: 27.5
});
// ====================================== ====================================== ====================================== SECTION 9
gsap.set(".co-home-9-content-crumble-2 img", { rotate: 0, x: "0%", y: "0%", scale: 1 });
gsap.to(".co-home-9-content-crumble-2 img", {
  scrollTrigger: {
    trigger: ".co-home-9",
    endTrigger: ".co-home-10",
    start: "top bottom",
    end: "top top",
    scrub: true
  },
  x: "-30%",
  y: "10%",
  rotate: -30,
  scale: 0.95
});